import { NavLink } from 'react-router';
import { cn } from '@dinewise/utils';
import { paymentsFloatingNavItems } from './payments-floating-nav.config.ts';

export const PaymentsFloatingNav = () => {
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-5 z-40 flex justify-center">
      <nav
        aria-label="Payments navigation"
        className={cn(
          'pointer-events-auto flex h-12 items-center gap-6 rounded-full border border-ande-gray-200',
          'bg-white px-5 shadow-[0_4px_12px_rgba(0,0,0,0.12)]',
        )}
      >
        {paymentsFloatingNavItems.map(item => {
          const { Icon } = item;

          return (
            <NavLink
              key={item.id}
              to={item.to}
              end={item.end}
              aria-label={item.label}
              className={({ isActive }) =>
                cn(
                  'flex size-9 items-center justify-center rounded-full transition-colors',
                  isActive && 'bg-ande-black-8',
                )
              }
            >
              {({ isActive }) => (
                <Icon
                  aria-hidden="true"
                  className={cn('size-[22px]', isActive ? 'text-ande-black' : 'text-ande-gray-500')}
                />
              )}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};
